// Spherio Living brand mark — line-art peaked house with a 4-pane window and a
// stylised gold leafy branch, both grounded on a soft curve. Matches the
// official social-media logo, restyled to site colours.
//   • House lines + window + ground use currentColor, so the icon reads white
//     on the navy hero/footer and deep-navy on the scrolled navbar.
//   • Leaves & stem use the site gold gradient (#D4B47A → #9C7A44).

export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Spherio Living"
    role="img"
    className={className}
  >
    <defs>
      <linearGradient id="sl-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#D4B47A" />
        <stop offset="1" stopColor="#9C7A44" />
      </linearGradient>
    </defs>

    {/* Leafy branch — stem */}
    <path
      d="M 14 33 C 13 27 11 21 8 11"
      fill="none"
      stroke="url(#sl-gold)"
      strokeWidth="1"
      strokeLinecap="round"
    />

    {/* Leaves — alternating pairs along the stem */}
    <path d="M 8 11 Q 3.5 10 4.5 5.5 Q 9 7 8 11 Z" fill="url(#sl-gold)" />
    <path d="M 9.5 15 Q 14 13 14 8.5 Q 9.5 10.5 9.5 15 Z" fill="url(#sl-gold)" />
    <path d="M 10.5 19 Q 5 18 5 13.5 Q 10.5 14.5 10.5 19 Z" fill="url(#sl-gold)" />
    <path d="M 12 23 Q 16.5 21.5 16.5 17 Q 12 18.5 12 23 Z" fill="url(#sl-gold)" />
    <path d="M 13 27.5 Q 7 26.5 7 22 Q 13 23 13 27.5 Z" fill="url(#sl-gold)" />

    {/* House outline — peaked roof with chimney */}
    <path
      d="M 20 33 L 20 19 L 30 9 L 34 13 L 34 10.5 L 37 10.5 L 37 16 L 40 19 L 40 33"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
      strokeLinecap="round"
    />

    {/* 4-pane window */}
    <rect
      x="27"
      y="22.5"
      width="6"
      height="6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
    />
    <line x1="30" y1="22.5" x2="30" y2="28.5" stroke="currentColor" strokeWidth="1" />
    <line x1="27" y1="25.5" x2="33" y2="25.5" stroke="currentColor" strokeWidth="1" />

    {/* Ground curve — connects the branch and the house */}
    <path
      d="M 4 35.5 Q 14 38.5 24 34.5 T 44 35.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);
